import { gsap, Linear } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { returnCoordinateAnimation } from "../app";

export default function initTeamArchive(isMobile, isTouch) {
  if (!document.querySelector(".team-archive")) return;
  gsap.registerPlugin(ScrollTrigger);
  if (isMobile) {
  } else {
    if (isTouch) {
    } else {
// Declare mainScrub variable outside the function
var mainScrub;

function initScrollTrigger() {
  let contentWidth = document.querySelector(".team-archive__hero").clientWidth;
  document
    .querySelectorAll(".team-archive__list--item")
    .forEach((item) => (contentWidth += item.clientWidth));

  mainScrub = gsap.to(".team-archive__inner", {
    x: -(contentWidth - window.innerWidth + 105),
    ease: Linear.easeNone,
    scrollTrigger: {
      trigger: ".team-archive",
      pin: true,
      scrub: true,
      end: "+=3000",
    },
  });
}

// Initialize ScrollTrigger on page load
initScrollTrigger();

// Reinitialize ScrollTrigger on window resize
window.addEventListener("resize", () => {
  if (mainScrub) {
    mainScrub.scrollTrigger.kill(); // Kill the ScrollTrigger associated with mainScrub
    mainScrub.kill(); // Kill the mainScrub timeline
    gsap.set(".team-archive__inner", { clearProps: "all" }); // Reset the GSAP properties on the target element
    initScrollTrigger(); // Reinitialize ScrollTrigger
  }
});

      var heroScrub = gsap.timeline({
        scrollTrigger: {
          trigger: ".team-archive__hero",
          start: "left left+=5%",
          end: "70% left",
          scrub: true,
          containerAnimation: mainScrub,
        },
      });
      returnCoordinateAnimation(heroScrub, ".team-archive__hero--coord");
    }
  }
}
